module.exports = __webpack_public_path__ + "img/facebook.1e80416a.svg";